module.exports = __webpack_public_path__ + "img/logo.e81e4c8e.png";